import { getLocalStorageItem } from './localstorage';

export const signedOutWithinLastNSeconds = (nSeconds: number): boolean =>
  !!getLocalStorageItem('signOut') &&
  Date.now() - Number(getLocalStorageItem('signOut') || '0') < nSeconds * 1000;
